import { render, staticRenderFns } from "./PageLandingCreators.vue?vue&type=template&id=65ae2636&scoped=true&"
import script from "./PageLandingCreators.vue?vue&type=script&lang=ts&"
export * from "./PageLandingCreators.vue?vue&type=script&lang=ts&"
import style0 from "./PageLandingCreators.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PageLandingCreators.vue?vue&type=style&index=1&id=65ae2636&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ae2636",
  null
  
)

export default component.exports